import type { AutocompleteProps as MuiAutocompleteProps } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { StyledAutocomplete, StyledPopper } from './Autocomplete.style';

import ArrowDownIcon from 'shared/icons/ArrowDown';

type AutocompleteProps<T> = Pick<
  MuiAutocompleteProps<T, false, false, false>,
  | 'value'
  | 'options'
  | 'getOptionLabel'
  | 'groupBy'
  | 'onChange'
  | 'isOptionEqualToValue'
>;

const Autocomplete = <T extends unknown>(props: AutocompleteProps<T>) => {
  return (
    <StyledAutocomplete
      {...props}
      popupIcon={<ArrowDownIcon sx={{ fontSize: '19px' }} />}
      // @ts-ignore
      PopperComponent={StyledPopper}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
          }}
        />
      )}
    />
  );
};

export default Autocomplete;
